/*
|--------------------------------------------------------------------------
| Generic Remedy Brand Search
|--------------------------------------------------------------------------
*/

window.BrandSearch = {

    aliases: {},

    init() {

        fetch("https://script.google.com/macros/s/AKfycbw_gy-xs1xhHjBqgTXYd0hXcGeNpxpaJ3x3bcGegHJ2cOEw6ScOodCs68KqsVO68Ozi/exec")
            .then(r => r.json())
            .then(data => {

                this.aliases = data;

                console.log("Brand aliases loaded", this.aliases);

            })
            .catch(err => {

                console.error("Brand Alias Error", err);

            });

    },

    find(searchTerm) {

        searchTerm = searchTerm.toLowerCase().trim();

        // Exact match
        if (this.aliases[searchTerm]) {
            return this.aliases[searchTerm];
        }

        // Partial match
        for (const alias in this.aliases) {

            if (alias.startsWith(searchTerm)) {
                return this.aliases[alias];
            }

        }

        return searchTerm;

    }

};

window.BrandSearch.init();